import { Spinner } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import Historie from "../../Components/Historie";
import MultiStepProgressBar from "../../Components/ProgressBar/MultiStepProgressBar";
import TextBauSteine from "../../Components/TextbauSteine";
import { useAuth } from "../../Store/auth-context";
import { useScheinContext } from "../../Store/schein-context";
import { useUIContext } from "../../Store/ui-context";
import CheckPage from "../CheckPage/CheckPage";
import FinalPage from "../FinalPage/FinalPage";
import Info from "../Info/Info";
import KundenSuche from "../KundenSuche/KundenSuche";
import Leistung from "../Leistung/Leistung";
import Summary from "../Summary/Summary";

const ServicescheinOverviewPage = () => {
  const { token, loading } = useAuth();
  const { persistSchein } = useScheinContext();
  const { currentPage, setCurrentPage } = useUIContext();

  const {
    showTextbauSteine,
    showHistorie,
  } = useUIContext();

  const nextPage = (page: any) => {
    setCurrentPage(page);
    persistSchein();
  };

  const nextPageNumber = (pageNumber: any) => {
    switch (pageNumber) {
      case "1":
        break;
      case "2":
        break;
      case "3":
        break;
      case "4":
        break;
      case "5":
        break;
      case "6":
        break;
      default:
    }
  };

  function textSelectedDummy(text: string) {
    console.log("textselected: " + text);
  }

  let content = (
    <>
      {loading === true ? (
        <>
          <Spinner />
        </>
      ) : (
        <>
          {token ? (
            <>
              <div className="text-center min-h-[80vh] items-center justify-center overscroll-contain">
                {{
                  kundensuche: <KundenSuche onButtonClick={nextPage} />,
                  leistung: <Leistung onButtonClick={nextPage} />,
                  info: <Info onButtonClick={nextPage} />,
                  summary: <Summary onButtonClick={nextPage} />,
                  checkpage: <CheckPage onButtonClick={nextPage} />,
                  finalpage: <FinalPage onButtonClick={nextPage} />,
                }[currentPage] || <div>Page not found</div>}
              </div>
              <footer className="mt-10 relative left-0 bottom-0 right-0 h-10 pb-7">
                <MultiStepProgressBar
                  page={currentPage}
                  onPageNumberClick={nextPageNumber}
                />
              </footer>
            </>
          ) : (
            <div>
              <Navigate to={"/login"} />
            </div>
          )}
        </>
      )}
    </>
  );

  if (showTextbauSteine && currentPage !== "info") {
    content = (
      <div className="w-full mx-auto">
        <TextBauSteine textSelected={textSelectedDummy} />
      </div>
    );
  }

  if (showHistorie) {
    content = <Historie />;
  }

  return <>{content}</>;
};

export default ServicescheinOverviewPage;
